import { useEffect, useRef, type ReactNode } from 'react';
import { HEADING } from '../../components/ui';

/**
 * A step's `h1`, focused when the step appears, so a screen reader starts reading at the new step
 * rather than wherever the pressed button used to be. Focused once, on mount: never again while the
 * patient types below it.
 */
export function StepHeading({ children }: { children: ReactNode }) {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    heading.current?.focus();
  }, []);
  return (
    <h1 ref={heading} tabIndex={-1} className={HEADING}>
      {children}
    </h1>
  );
}
